import TransactionCategoryEdit from "@/controllers/transaction_category/transaction-category-edit.js";

export default {
    extends: TransactionCategoryEdit,
};
